export const univercityFriendLinks = [
  {
    url: 'http://cet4-6.xdf.cn/',
    title: '英语四六级'
  },
  {
    url: 'http://kaoyan.xdf.cn/',
    title: '新东方考研'
  },
  {
    url: 'http://toefl.xdf.cn/',
    title: '托福考试'
  },
  {
    url: 'http://ielts.xdf.cn/',
    title: '雅思考试'
  },
  {
    url: 'http://sat.xdf.cn/',
    title: 'SAT考试'
  },
  {
    url: 'http://act.xdf.cn/',
    title: 'ACT考试'
  },
  {
    url: 'http://xiaoxue.xdf.cn/',
    title: '小学辅导'
  },
  {
    url: 'http://zhongkao.xdf.cn/',
    title: '中学考试'
  },
  {
    url: 'http://gaokao.xdf.cn/',
    title: '高考复习'
  },
  {
    url: 'http://yingyu.xdf.cn/',
    title: '英语学习'
  },
  {
    url: 'http://gre.xdf.cn/',
    title: 'GRE考试'
  },
  {
    url: 'http://gmat.xdf.cn/',
    title: 'GMAT考试'
  },
  {
    url: 'http://toefl.xdf.cn/zhuanti/kecheng.html',
    title: '托福培训'
  }
]



// WEBPACK FOOTER //
// ./src/api/js/univercity/friendlinks.js